import React, { useState } from 'react';
import '../styles/components.css';
import Button from './Button.js';

function GradientCard(props) {
  const IconProp = props.icon;
  return (
    <div className='card'>
      <div className='icon'><IconProp /></div>
      <h3>{props.title}</h3>
      <p>{props.desc}</p>
    </div>
  );
}

function GradientCardNoIcon(props) {
  const latitude = props.latitude;
  const longitude = props.longitude;

  const [showMap, setShowMap] = useState(false); // Toggle map visibility

  const handleMapBtn = () => {
    setShowMap(prev => !prev); // Toggle map visibility
  };

  // Function to open the map in a new tab on map click
  const handleMapClick = () => {
    const url = `https://www.google.com/maps?q=${latitude},${longitude}&z=14`;
    window.open(url, '_blank');
  };

  return (
    <div className="cardNoIcon card" style={{ position: 'relative', height: "40vh" }}>
      {/* Conditionally render branch details only when map is not visible */}
      {!showMap && (
        <>
          <h3>{props.title}</h3>
          <p><span>{props.title1}</span>{props.desc1}</p>
          <p><span>{props.title2}</span><br />{props.desc2}</p>
        </>
      )}

      {/* Button to toggle map visibility - Show Map */}
      {!showMap && (
        <Button 
          onClick={handleMapBtn} 
          text={"Show Map"} 
          style={{ position: 'absolute', top: 10, right: 10, zIndex: 5 }}
        />
      )}

      {/* Show map only when toggled */}
      {showMap && (
        <div className="map-container">
          {/* The iframe that shows the map */}
          <iframe
            width="100%"
            height="255px"
            src={`https://www.google.com/maps?q=${latitude},${longitude}&z=14&output=embed`} 
            allowFullScreen
            title="Google Map"
            style={{ cursor: 'pointer' }} 
            onClick={handleMapClick} // Handle opening the map in a new tab on click
          />
          
          {/* Button to hide the map */}
          <Button 
            onClick={handleMapBtn} 
            text={"Hide Map"} 
            style={{ position: 'absolute', top: 10, right: 10, zIndex: 5 }}
          />
        </div>
      )}
    </div>
  );
}

export { GradientCard, GradientCardNoIcon };
